import "core-js/modules/es.array.find";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, packageData } from "@/mixins/index";
import addMotherPackageType from "./components/addMotherPackageType";
import parameterAnyPopup from "@/components/parameterAnyPopup/parameterAnyPopup";
export default {
  name: "motherPackageType",
  mixins: [loadMoreList, packageData],
  components: {
    addMotherPackageType: addMotherPackageType,
    parameterAnyPopup: parameterAnyPopup
  },
  data: function data() {
    return {
      pagingReqFn: "originPkgTypeList",
      delIds: [],
      loginData: ''
    };
  },
  activated: function activated() {
    this.getcommonData(['originPkgTypeList']);
    this.getList();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    del: function del(dateList) {
      var _this = this;

      var ids = dateList.map(function (item) {
        return item.id;
      }).toString();
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'originPkgTypeDel',
        data: {
          id: ids
        }
      }).then(function () {
        _this.getList(_this.paramsData.page);
      });
    },
    pkgTypeChange: function pkgTypeChange(e) {
      if (e) {
        var data = this.originPkgTypeList.find(function (i) {
          return i.id == e;
        });
        this.paramsData.type_name = data.type_name;
        this.paramsData.id = data.id;
      } else {
        this.paramsData.type_name = '';
        this.paramsData.id = '';
      }
    }
  }
};